<template>
  <Photos year="2011" :min-date="1300233600" :max-date="1300406400" date-text="March 16&ndash;18" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
